<template>
    <div class="assignment-edit">
        <design-2021-lesson-module-assignment-edit-title-buttons-component
            @assignment-updated="updateAssignment"
            :lesson-module-in="lessonModuleIn"
            :assignment-in="dynamicAssignment">
        </design-2021-lesson-module-assignment-edit-title-buttons-component>

        <div class="assignment-edit-content">
            <div
                class="row"
                v-if="assignment">
                <div class="col-12 col-md-4 col-xl-3 assignment-edit-sidebar-menu">
                    <design-2021-lesson-module-assignment-sub-assignments-nav-component
                        @assignment-updated="updateAssignment"
                        @sub-assignment-added="addSubAssignment"
                        @sub-assignment-updated="updateSubAssignment"
                        :assignment-in="dynamicAssignment"
                        @selected-sub-assignment="changeSelectedSubAssignment($event)">
                    </design-2021-lesson-module-assignment-sub-assignments-nav-component>
                </div>

                <div
                    class="col-12 col-md-8 col-xl-9"
                    v-if="selectedSubAssignment">
                    <design-2021-lesson-module-assignment-sub-assignment-component
                        :assignment-in="dynamicAssignment"
                        @assignment-updated="updateAssignment"
                        @sub-assignment-updated="updateSubAssignment"
                        @sub-assignment-added="addSubAssignment"
                        @sub-assignment-removed="removeSubAssignment"
                        :sub-assignment-in="selectedSubAssignment">
                    </design-2021-lesson-module-assignment-sub-assignment-component>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { Common as common } from '../../../../../helpers/common';

export default {
    name: 'design-2021-lesson-module-assignment-edit-component',
    props: {
        assignmentIn: {
            type: Object,
            required: true,
        },
        lessonModuleIn: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            selectedSubAssignmentId: null,
            assignment: this.assignmentIn,
            subscription: null,
            feedback: this.assignmentIn.feedback ? this.assignmentIn.feedback : [],
        };
    },
    methods: {
        updateAssignment(newAssignment) {
            this.assignment = newAssignment;
            this.alert.success();
        },
        addSubAssignment(newSubAssignment) {
            this.assignment.sub_assignments.push(newSubAssignment);
            this.alert.success();
        },

        changeSelectedSubAssignment(id) {
            this.selectedSubAssignmentId = id;
        },

        updateSubAssignment(updatedSubAssignment) {
            this.assignment.sub_assignments = this.assignment.sub_assignments.map((subAssignment) => {
                if (updatedSubAssignment.id === subAssignment.id) {
                    return updatedSubAssignment;
                }
                return subAssignment;
            });

            this.alert.success();
        },

        removeSubAssignment(subAssignmentId) {
            this.assignment.sub_assignments = this.assignment.sub_assignments.filter(
                (subAssignment) => subAssignment.id !== subAssignmentId,
            );
            this.alert.success();
        },
    },
    computed: {
        common() {
            return common;
        },
        selectedSubAssignment() {
            for (const subAssignment of this.assignment.sub_assignments) {
                if (subAssignment.id === this.selectedSubAssignmentId) {
                    return subAssignment;
                }
            }
            return null;
        },
        dynamicAssignment() {
            return this.assignment;
        },
    },
};
</script>

<style scoped>
.sub-assignment-drag-handle {
    color: lightgray;
    margin-right: 15px;
}

.sub-assignment-drag-handle:hover {
    color: black;
}

.list-group-item {
    border: none;
    font-size: 0.875rem;
}

.list-group-item:hover,
.list-group-item.active {
    background-color: #e8eff4bf;
    color: #212529;
}

.edit-assignments .header {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    margin-bottom: 21px;
    flex-direction: column;
}

.edit-assignments .header >>> .actions {
    align-self: flex-end;
}

.sub-assignments-edit-nav {
    margin-bottom: 60px;
}

@media (min-width: 768px) {
    .sub-assignments-edit-nav {
        margin-bottom: 0px;
    }

    .edit-assignments .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 21px;
        flex-direction: row;
    }

    .edit-assignments .header >>> .actions {
        align-self: baseline;
    }
}
</style>
